<div class="content-overlay"
     *ngIf="!isConnected"
     style="position: fixed; left: 1px; right: 1px; bottom: 1px; z-index: 100; background-color: rgba(0, 0, 0, 0.2);"
     [style.top.px]="disconnectOverlayTopOffset"></div>
<router-outlet></router-outlet>
